import api from '../api';
import { handleError } from './helper';

export const updateSelectedSize = (size) => (dispatch) =>
  dispatch({
    type: 'UPDATE_SELECTED_SIZE',
    payload: size,
  });

export const updateSelectedUnitType = (type) => (dispatch) =>
  dispatch({
    type: 'UPDATE_SELECTED_UNIT',
    payload: type,
  });

export const getPriceCards = (data) => (dispatch) => {
  dispatch({
    type: 'IS_LOADING',
  });
  // -- enable this code to use local storage data when required

  // if (process.env.NODE_ENV === 'development' && localStorage.getItem('data')) {
  //   dispatch({
  //     type: 'FETCH_DATA_SUCCESS',
  //     payload: JSON.parse(localStorage.getItem('data')),
  //   });
  //   dispatch({
  //     type: 'IS_NOT_LOADING',
  //   });
  // } else {
  api
    .getPriceCards(data)
    .then((res) => {
      localStorage.setItem(
        'data',
        JSON.stringify({
          priceCards: res[0].data.data || [],
          kpi: res[1].data,
        })
      );
      dispatch({
        type: 'FETCH_DATA_SUCCESS',
        payload: { priceCards: res[0].data.data || [], kpi: res[1].data },
      });
    })
    .catch((err) => {
      handleError(dispatch, err);
      dispatch({
        type: 'FETCH_DATA_FAILURE',
        payload: {},
      });
    })
    .finally(() => {
      dispatch({
        type: 'IS_NOT_LOADING',
      });
    });
  // }
};

export const UpdateSelectedTab = (tab) => (dispatch) =>
  dispatch({
    type: 'UPDATE_SELECTED_TAB',
    payload: tab,
  });

export const updateStatusAll = (payload) => (dispatch) => {
  dispatch({
    type: 'IS_LOADING',
  });
  api
    .updateStatusAll(payload)
    .then((res) => {
      dispatch({
        type: 'UPDATE_STATUS_ALL',
        payload: payload,
      });
      if (payload.status === 'approved') {
        let unit = '';
        if (payload.unitType === 'Any') unit = 'All';
        else unit = payload.unitType;
        dispatch({
          type: 'SHOW_NOTIFICATION',
          payload: { message: `${unit} units Approved`, type: 'success' },
        });
      }
    })
    .catch((err) => {
      handleError(dispatch, err);
    });
};

export const updateStatus = (payload) => (dispatch) => {
  let input = {
    store: payload.item.store,
    unitType: payload.item.unitType,
    unitWidth: payload.item.unitWidth,
    status: payload.status,
  };
  api
    .updateStatus(input)
    .then((res) => {
      dispatch({
        type: 'UPDATE_STATUS',
        payload: payload,
      });
    })
    .catch((err) => {
      handleError(dispatch, err);
    });
};

export const getDiscountsData = () => async (dispatch) => {
  dispatch({ type: 'IS_LOADING' });
  try {
    const res = await api.getDiscounts();
    dispatch({
      type: 'FETCH_DISCOUNTS_SUCCESS',
      payload: res.data || [],
    });
  } catch (err) {
    handleError(dispatch, err);
  } finally {
    dispatch({ type: 'IS_NOT_LOADING' });
  }
};

export const getDiscountOptions = (SLSiteCode) => async (dispatch) => {
  dispatch({ type: 'FETCH_DISCOUNT_OPTIONS_REQUEST' });
  try {
    const res = await api.getDiscountOptions({ SLSiteCode });
    dispatch({
      type: 'FETCH_DISCOUNTS_OPTIONS_SUCCESS',
      payload: res.data || [],
    });
    return res.data;
  } catch (err) {
    dispatch({
      type: 'FETCH_DISCOUNT_OPTIONS_FAILURE',
      payload: err,
    });
    handleError(dispatch, err);
  } finally {
    dispatch({ type: 'IS_NOT_LOADING' });
  }
};

export const clearDiscountOptions = () => (dispatch) => {
  dispatch({
    type: 'CLEAR_DISCOUNTS_OPTIONS',
  });
};

export const getDiscountSuggestions = () => async (dispatch) => {
  try {
    const res = await api.getDiscountSuggestions();
    dispatch({
      type: 'FETCH_DISCOUNT_SUGGESTIONS_SUCCESS',
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: 'FETCH_DISCOUNT_SUGGESTIONS_FAILED',
      payload: err,
    });
    handleError(dispatch, err);
  } finally {
    // dispatch({ type: 'IS_NOT_LOADING' });
  }
};

export const approveDiscountSuggestion = (id) => async (dispatch) => {
  dispatch({ type: 'IS_LOADING' });
  try {
    const res = await api.approveDiscountSuggestion(id);
    const suggestion =
      res && res.data && res.data.suggestion ? res.data.suggestion : null;

    dispatch({
      type: 'APPROVE_DISCOUNT_SUGGESTION_SUCCESS',
      payload: suggestion,
    });

    dispatch({
      type: 'SHOW_NOTIFICATION',
      payload: {
        message: 'Discount suggestion approved successfully',
        type: 'success',
      },
    });
  } catch (err) {
    handleError(dispatch, err);
  } finally {
    dispatch({ type: 'IS_NOT_LOADING' });
  }
};

export const overrideDiscount = (overrideData, type) => async (dispatch) => {
  dispatch({ type: 'IS_LOADING' });
  const payload = {
    dealId: overrideData.dealId,
    unitId: overrideData.unitId,
    oldDealId: overrideData.oldDealId,
    newDealId: overrideData.newDealId,
    duration: overrideData.duration,
    reason: overrideData.reason,
    comment: overrideData.comment,
    oldDiscount: overrideData.oldDiscount,
    previousNewDiscount: overrideData.previousNewDiscount,
    updatedNewDiscount: overrideData.updatedNewDiscount,
    storeId: overrideData.StoreId,
    isOverridden: overrideData.isOverridden,
    type,
  };

  try {
    const res = await api.overrideUnitDiscount(payload);

    if (type === 'override')
      dispatch({
        type: 'UPDATE_DISCOUNT',
        payload: {
          unitIds: payload.unitId,
          dealId: payload.dealId,
          dealTitle: overrideData.discountTitle,
          duration: payload.duration,
          user: res.data.overriddenBy,
        },
      });

    dispatch({
      type: 'SHOW_NOTIFICATION',
      payload: {
        message:
          type === 'override'
            ? 'Discount overridden successfully'
            : 'Discount suggested successfully',
        type: 'success',
      },
    });

    if (type === 'suggest')
      dispatch({
        type: 'SUGGEST_DISCOUNT',
        payload: res.data.suggestion,
      });
    else dispatch(getDiscountsData());

    return res.data;
  } catch (err) {
    dispatch({
      type: 'SHOW_NOTIFICATION',
      payload: {
        message:
          type === 'override'
            ? 'Something went wrong while overriding discount'
            : 'Something went wrong while suggesting discount',
        type: 'error',
      },
    });
  } finally {
    dispatch({ type: 'IS_NOT_LOADING' });
  }
};

export const getDiscountLogHistory = (unitIds) => async (dispatch) => {
  dispatch({ type: 'FETCH_DISCOUNT_LOG_HISTORY_REQUEST' });
  try {
    const res = await api.getDiscountLogHistory(unitIds);
    dispatch({
      type: 'FETCH_DISCOUNT_LOG_HISTORY_SUCCESS',
      payload: res.data,
    });
    return res.data;
  } catch (err) {
    dispatch({
      type: 'FETCH_DISCOUNT_LOG_HISTORY_FAILURE',
      payload: err.message,
    });

    handleError(dispatch, err);
  } finally {
    dispatch({ type: 'IS_NOT_LOADING' });
  }
};

export const clearDiscountLogHistory = () => (dispatch) => {
  dispatch({
    type: 'CLEAR_DISCOUNT_LOG_HISTORY',
  });
};
